import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"
}), 'VerticalAlignTopOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VerticalAlignTopOutlined.js
// module id = 7021
// module chunks = 2